import { type YDatabase } from '@databases/collab/y-database';
import { err, ok, type Result } from 'neverthrow';

import { type SdkError } from '../../types.ts';

/**
 * Guards structural mutations against a locked database. Returns
 * `STATE_ERROR('DATABASE_LOCKED')` when the schema is locked; otherwise `ok`.
 */
export function assertNotLocked(ydb: YDatabase): Result<void, SdkError> {
  if (ydb.isLocked) {
    return err({
      type: 'STATE_ERROR',
      reason: 'DATABASE_LOCKED',
      message: 'Database structure is locked'
    });
  }

  return ok(undefined);
}
